<template>
    <div class="login">
        <h4 class="login__desc"><em>{{ '이대' + this.$store.getters.getHostNm }}</em> 홈페이지 회원 서비스는 로그인 후 이용하실 수 있습니다.</h4>
        <div class="login__inner">
            <div class="login__input login-top">
                <label class="flex">
                    <input type="text" class="input" placeholder="아이디" v-model="id">
                </label>
                <label class="flex">
                    <!-- active : .active -->
                    <input :type="this.pwIcon ? 'text' : 'password'" class="pw input" :class="{active : this.pwIcon}" placeholder="비밀번호" v-model="pass" @keyup.enter="loginSubmit">
                    <button type="button" @click="this.pwIcon = !this.pwIcon"></button>
                </label>
                <div class="checkbox-wrap">
                    <label>
                        <input type="checkbox" name="test-check01" id="check01" ref="saveId">
                        <span class="checkbox-btn"></span>
                        <p>아이디저장</p>
                    </label>
                </div>
                <div class="botton-wrap">
                    <button type="submit" class="main-button c-main" @click="loginSubmit">로그인</button>
                </div>

                <ul class="login__list">
                    <li class="login__item">
                        <router-link to="/kr/findId">아이디 찾기</router-link>
                    </li>
                    <li class="login__item">
                        <router-link to="/kr/findPw">비밀번호 찾기</router-link>
                    </li>
                    <li class="login__item">
                        <router-link to="/kr/join">회원가입</router-link>
                    </li>
                </ul>
            </div>

            <div class="login-top">
                <h5 class="tit">네이버 로그인</h5>
                <div class="botton-wrap" id="naver_id_login">
                    <button type="submit" class="main-button naver"><img src="@/assets/resource/icon/naver-icon.svg" alt=""> 네이버 아이디로 로그인</button>
                </div>
                <p class="login__desc type2">※인터넷 익스플로러(IE)에서는 <br class="pc-none"> 네이버 아이디로 로그인이 불가합니다.</p>
            </div>
        </div>
    </div>
    <kr_popup_sleeping ref="sleep" :id="id" :pass="pass"></kr_popup_sleeping>
</template>
<script>
    export default {
        components: {
            
        },
        data() {
            return {
                pwIcon: false,
                id: '',
                pass: '',
            }
        },
        mounted() {
            // 네아로
            const naverKey = this.$store.getters.getHost == 'H0006' ? 'sjDQkpmw6pb9qemQ_HBM' : 'eOFRTLDGI3a72IRuLeZW'
            var naver_id_login = new window.naver_id_login(naverKey, location.origin + "/kr/login");
            var state = naver_id_login.getUniqState();
            naver_id_login.setButton("green", 3, 48);
            naver_id_login.setDomain(location.origin);
            naver_id_login.setState(state);
            naver_id_login.setPopup();
            naver_id_login.init_naver_id_login();
            // 네아로 접근시
            if (this.$route.hash != '') {
                this.naverApiLogin();
            }
            
            const saveChecked = localStorage.getItem("saveChecked")
            const saveId = localStorage.getItem("saveId")
            if(saveChecked){
                this.$refs.saveId.checked = saveChecked
                this.id = saveId
            }
        },
        methods: {
            loginSubmit(){
                if(this.id.indexOf('@') > -1) {
                    alert("올바르지 않은 아이디 형태입니다.\n네이버 아이디는 '네이버 아이디로 로그인' 버튼을 클릭해 주세요.");
                    return
                }
                if(!this.id){
                    alert('아이디를 입력해주세요.')
                    return
                }
                if(!this.pass){
                    alert('비밀번호를 입력해주세요.')
                    return
                }

                const params = new URLSearchParams();
                params.append('id', this.id);
                params.append('pass', this.pass);

                this.axios.post(this.api.member.login, params)
                .then(res => {
                    const saveChecked = this.$refs.saveId.checked
                    if(saveChecked){
                        localStorage.setItem("saveChecked", true);
                        localStorage.setItem("saveId", this.id);
                    }

                    if(res.status == 200){
                        const data = res.data.result
                        if(data.status){
                            this.$store.commit('setNaverYn', 'N')
                            const now = new Date()
                            const nowTime = now.getTime()
                            this.$store.commit('setLoginDt', nowTime)
                            this.setMyInfoStore(data)
                        }else{
                            alert(data.message)
                            if(data.code && data.code == 'E_CHANGE_PW'){
                                this.setMyInfoStore(data)
                            }else if(data.code && data.code == 'E_WRONG_Z'){
                                this.$refs.sleep.popupShow = true
                            }
                        }
                    }else{
                        alert('다시 시도해주시길 바랍니다.')
                        location.reload();
                    }
                })
            },
            // hash의 accessToken 추출
            accessToken() {
                const hash = this.$route.hash;
                const result = hash.substring(hash.indexOf("access_token") + 13, hash.indexOf("&state"));
                return result
            },
            // accessToken으로 로그인
            naverApiLogin() {
                this.axios.get('/api/naverInfo.do', {
                    params: {
                        access_token: this.accessToken()
                    }
                })
                    .then(res => {
                        const data = res.data.response;
                        const naverId = data.id;
                        const naverEmail = data.email;
                        const naverName = data.name;
                        const gender = data.gender;
                        if (naverEmail == null || naverName == null) {
							alert('네이버 회원가입 시 다음 항목은 필수사항입니다. (필수항목 : 이름, 성별, 이메일, 생일)')
                            return
						}
                        if (naverEmail.indexOf("-") > -1) {
							alert('네이버 회원 정보의 연락처 이메일 값을 불러올 수 없습니다.\n네이버에서 연락처 이메일 정보를 수정해 주세요.')
                            return
						}
                        const params = new URLSearchParams();
                        params.append('id', naverEmail);
                        // params.append('pass', null);
                        
                        this.axios
                            .post(this.api.member.login, params)
                            .then((res) => {
                                if (res.status === 200) {
                                    this.$store.commit('setNaverYn', 'Y')
                                    if (res.data.result.status === true) {
                                        this.$store.commit('setStatus', true);
                                        this.setMyInfoStore(res.data);
                                        window.opener.location.href = location.origin
                                    } else {
                                        if(res.data.result.code == 'E_WRONG_ID'){
                                            this.$store.commit('setNaverEmail', naverEmail)
                                            this.$store.commit('setNaverName', naverName)
                                            window.opener.location.href = location.origin + '/kr/join'
                                        }else{
                                            alert(res.data.result.message);
                                            if(data.code && data.code == 'E_WRONG_Z'){
                                                this.$refs.sleep.popupShow = true
                                            }
                                        }
                                    }
                                    window.close()
                                } else {
                                    alert('다시 시도해주시길 바랍니다.')
                                }
                                // window.self.close()
                            })
                            .catch((err) => window.self.close());
                    })
            },
            setMyInfoStore(data) {
                this.axios.get(this.api.member.info)
                    .then(res => {
                        this.$store.state.myInfoStore = res.data;
                        this.$store.commit('setStatus', true);
                        if(data.code && data.code == 'E_CHANGE_PW'){
                            this.$router.push('/kr/mypage/member/updateMember')
                        }else if(this.$store.getters.getPrevUrl){
                            location.href = this.$store.getters.getPrevUrl;
                        }else{
                            this.$router.replace('/');
                        }
                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
        },
    }

</script>
<style>

</style>